import { useChat } from '@r1-frontend/entities/Chat/hooks/useChat';

import { Button, TButtonType } from '@r1-frontend/ui-kit/atoms/button';

interface IProps {
    children?: JSX.Element | JSX.Element[] | string,
    clickHandle?: () => void,
    $type?: TButtonType,
    [name: string]: unknown,
}

const OpenChatButton = ({ children = 'Написать в чат', $type = 'accent', clickHandle, ...rest }: IProps) => {
    const { open } = useChat();

    const onClick = () => {
        open();

        if (typeof clickHandle === 'function') {
            clickHandle();
        }
    };

    return <Button $type={$type} onClick={onClick} {...rest}>{children}</Button>;
};

export default OpenChatButton;
